import { Pipe, PipeTransform } from '@angular/core';
import { CountriesService } from '@zero/onboarding/domain';
import { TinErrorPipe } from './tin-error.pipe';

@Pipe({
  name: 'tin',
  standalone: true,
})
export class TinPipe implements PipeTransform {
  constructor(public readonly countriesService: CountriesService) {}

  public transform(value: string, country: string): boolean {
    if (!value || !country) {
      return null;
    }
    return new TinErrorPipe(this.countriesService).transform(value, country) === null;
  }
}
